module.exports = __webpack_public_path__ + "static/media/buiness-backg-1.8f3c47d3.png";